import React, { Component } from "react";

import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import { addPaymentFormulas, getPaymentFormulasParams } from "../../../store/payment-formula/actions";
import PropTypes from "prop-types";
import PaymentFormulasCalculator from "./components/PaymentFormulasCalculator";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class AddPaymentFormulas extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getPaymentFormulasParams();
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Add payment formula | Mobihunter" />
  
          <Container fluid>
            <Breadcrumbs
              title="Payment Formulas"
              breadcrumbItem="Add payment formulas"
              link="/payment-formulas"
            />
            <PaymentFormulasCalculator data={this.props.data}
                                       paymentData={this.props.paymentData}
                                       history={this.props.history}
                                       addPaymentFormulas={this.props.addPaymentFormulas}
                                       permissions={this.props.permissions}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddPaymentFormulas.propTypes = {
  data: PropTypes.any,
  paymentData: PropTypes.any,
  history: PropTypes.any,
  getPaymentFormulasParams: PropTypes.func,
  addPaymentFormulas: PropTypes.func,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  data: state.PaymentFormulas.absolute_params,
  paymentData: state.PaymentFormulas.data,
  permissions: state.User.permissions
});

export default connect(mapStateToProps, {
  getPaymentFormulasParams,
  addPaymentFormulas
})(AddPaymentFormulas);
